/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { AssignPayoutPolicyDto } from "../types/assignPayoutPolicyDto";

import type { CreatePayeeOrganizationDto } from "../types/createPayeeOrganizationDto";

import type { GetPayeeOrganizationCandidatesParams } from "../types/getPayeeOrganizationCandidatesParams";

import type { PayeeOrganizationCandidateDto } from "../types/payeeOrganizationCandidateDto";

import type { PayeeOrganizationDto } from "../types/payeeOrganizationDto";

import type { PayeePayoutTermsDto } from "../types/payeePayoutTermsDto";

import type { ProblemDetails } from "../types/problemDetails";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * **Required Permission(s):** ORG_PAYEE_LIST
 */
export const listPayeeOrganizations = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeeOrganizationDto[]>> => {
  return axios.default.get(`/api/payee-organizations`, options);
};

export const getListPayeeOrganizationsQueryKey = () => {
  return [`/api/payee-organizations`] as const;
};

export const getListPayeeOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPayeeOrganizations>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPayeeOrganizations>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPayeeOrganizationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPayeeOrganizations>>
  > = ({ signal }) => listPayeeOrganizations({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPayeeOrganizations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPayeeOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPayeeOrganizations>>
>;
export type ListPayeeOrganizationsQueryError = AxiosError<void>;

export function useListPayeeOrganizations<
  TData = Awaited<ReturnType<typeof listPayeeOrganizations>>,
  TError = AxiosError<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPayeeOrganizations>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPayeeOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYEE_UPDATE
 */
export const createPayeeOrganization = (
  createPayeeOrganizationDto: CreatePayeeOrganizationDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeeOrganizationDto>> => {
  return axios.default.post(
    `/api/payee-organizations`,
    createPayeeOrganizationDto,
    options,
  );
};

export const getCreatePayeeOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayeeOrganization>>,
    TError,
    { data: CreatePayeeOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPayeeOrganization>>,
  TError,
  { data: CreatePayeeOrganizationDto },
  TContext
> => {
  const mutationKey = ["createPayeeOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPayeeOrganization>>,
    { data: CreatePayeeOrganizationDto }
  > = (props) => {
    const { data } = props ?? {};

    return createPayeeOrganization(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePayeeOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPayeeOrganization>>
>;
export type CreatePayeeOrganizationMutationBody = CreatePayeeOrganizationDto;
export type CreatePayeeOrganizationMutationError =
  AxiosError<ProblemDetails | void>;

export const useCreatePayeeOrganization = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayeeOrganization>>,
    TError,
    { data: CreatePayeeOrganizationDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPayeeOrganization>>,
  TError,
  { data: CreatePayeeOrganizationDto },
  TContext
> => {
  const mutationOptions = getCreatePayeeOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYEE_LIST
 */
export const getPayeeOrganizationCandidates = (
  params: GetPayeeOrganizationCandidatesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeeOrganizationCandidateDto[]>> => {
  return axios.default.get(`/api/payee-organizations/candidates`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetPayeeOrganizationCandidatesQueryKey = (
  params?: GetPayeeOrganizationCandidatesParams,
) => {
  return [
    `/api/payee-organizations/candidates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPayeeOrganizationCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayeeOrganizationCandidates>>,
  TError = AxiosError<ProblemDetails | void>,
>(
  params: GetPayeeOrganizationCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayeeOrganizationCandidates>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPayeeOrganizationCandidatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayeeOrganizationCandidates>>
  > = ({ signal }) =>
    getPayeeOrganizationCandidates(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayeeOrganizationCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayeeOrganizationCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayeeOrganizationCandidates>>
>;
export type GetPayeeOrganizationCandidatesQueryError =
  AxiosError<ProblemDetails | void>;

export function useGetPayeeOrganizationCandidates<
  TData = Awaited<ReturnType<typeof getPayeeOrganizationCandidates>>,
  TError = AxiosError<ProblemDetails | void>,
>(
  params: GetPayeeOrganizationCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayeeOrganizationCandidates>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayeeOrganizationCandidatesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getPayeeOrganizationById = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeeOrganizationDto>> => {
  return axios.default.get(`/api/payee-organizations/${id}`, options);
};

export const getGetPayeeOrganizationByIdQueryKey = (id?: string) => {
  return [`/api/payee-organizations/${id}`] as const;
};

export const getGetPayeeOrganizationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayeeOrganizationById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayeeOrganizationById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPayeeOrganizationByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayeeOrganizationById>>
  > = ({ signal }) => getPayeeOrganizationById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayeeOrganizationById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayeeOrganizationByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayeeOrganizationById>>
>;
export type GetPayeeOrganizationByIdQueryError =
  AxiosError<void | ProblemDetails>;

export function useGetPayeeOrganizationById<
  TData = Awaited<ReturnType<typeof getPayeeOrganizationById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayeeOrganizationById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayeeOrganizationByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYEE_DELETE
 */
export const deactivatePayeeOrganization = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeeOrganizationDto>> => {
  return axios.default.post(
    `/api/payee-organizations/${id}/deactivate`,
    undefined,
    options,
  );
};

export const getDeactivatePayeeOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivatePayeeOrganization>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivatePayeeOrganization>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deactivatePayeeOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivatePayeeOrganization>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deactivatePayeeOrganization(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivatePayeeOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivatePayeeOrganization>>
>;

export type DeactivatePayeeOrganizationMutationError =
  AxiosError<ProblemDetails | void>;

export const useDeactivatePayeeOrganization = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivatePayeeOrganization>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deactivatePayeeOrganization>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getDeactivatePayeeOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYEE_UPDATE
 */
export const reactivatePayeeOrganization = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeeOrganizationDto>> => {
  return axios.default.post(
    `/api/payee-organizations/${id}/reactivate`,
    undefined,
    options,
  );
};

export const getReactivatePayeeOrganizationMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivatePayeeOrganization>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reactivatePayeeOrganization>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["reactivatePayeeOrganization"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reactivatePayeeOrganization>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return reactivatePayeeOrganization(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReactivatePayeeOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof reactivatePayeeOrganization>>
>;

export type ReactivatePayeeOrganizationMutationError =
  AxiosError<ProblemDetails | void>;

export const useReactivatePayeeOrganization = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reactivatePayeeOrganization>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof reactivatePayeeOrganization>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getReactivatePayeeOrganizationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getPayeeOrganizationPayoutTerms = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeePayoutTermsDto>> => {
  return axios.default.get(
    `/api/payee-organizations/${id}/payout-terms`,
    options,
  );
};

export const getGetPayeeOrganizationPayoutTermsQueryKey = (id?: string) => {
  return [`/api/payee-organizations/${id}/payout-terms`] as const;
};

export const getGetPayeeOrganizationPayoutTermsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayeeOrganizationPayoutTerms>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayeeOrganizationPayoutTerms>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPayeeOrganizationPayoutTermsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayeeOrganizationPayoutTerms>>
  > = ({ signal }) =>
    getPayeeOrganizationPayoutTerms(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayeeOrganizationPayoutTerms>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayeeOrganizationPayoutTermsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayeeOrganizationPayoutTerms>>
>;
export type GetPayeeOrganizationPayoutTermsQueryError =
  AxiosError<void | ProblemDetails>;

export function useGetPayeeOrganizationPayoutTerms<
  TData = Awaited<ReturnType<typeof getPayeeOrganizationPayoutTerms>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayeeOrganizationPayoutTerms>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayeeOrganizationPayoutTermsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_PAYEE_ASSIGN_PAYOUT_POLICY
 */
export const assignPayeeOrganizationPayoutPolicy = (
  id: string,
  assignPayoutPolicyDto: AssignPayoutPolicyDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PayeePayoutTermsDto>> => {
  return axios.default.post(
    `/api/payee-organizations/${id}/assign-payout-policy`,
    assignPayoutPolicyDto,
    options,
  );
};

export const getAssignPayeeOrganizationPayoutPolicyMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPayeeOrganizationPayoutPolicy>>,
    TError,
    { id: string; data: AssignPayoutPolicyDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignPayeeOrganizationPayoutPolicy>>,
  TError,
  { id: string; data: AssignPayoutPolicyDto },
  TContext
> => {
  const mutationKey = ["assignPayeeOrganizationPayoutPolicy"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignPayeeOrganizationPayoutPolicy>>,
    { id: string; data: AssignPayoutPolicyDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignPayeeOrganizationPayoutPolicy(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignPayeeOrganizationPayoutPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignPayeeOrganizationPayoutPolicy>>
>;
export type AssignPayeeOrganizationPayoutPolicyMutationBody =
  AssignPayoutPolicyDto;
export type AssignPayeeOrganizationPayoutPolicyMutationError =
  AxiosError<ProblemDetails | void>;

export const useAssignPayeeOrganizationPayoutPolicy = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignPayeeOrganizationPayoutPolicy>>,
    TError,
    { id: string; data: AssignPayoutPolicyDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignPayeeOrganizationPayoutPolicy>>,
  TError,
  { id: string; data: AssignPayoutPolicyDto },
  TContext
> => {
  const mutationOptions =
    getAssignPayeeOrganizationPayoutPolicyMutationOptions(options);

  return useMutation(mutationOptions);
};
